const jaTranslations = {
  // Common
  common: {
    loading: '読み込み中...',
    error: 'エラー',
    save: '保存',
    cancel: 'キャンセル',
    add: '追加',
    update: '更新',
    delete: '削除',
    deleting: '削除中...',
    edit: '編集',
    view: '表示',
    download: 'ダウンロード',
    upload: 'アップロード',
    share: '共有',
    search: '検索',
    filter: 'フィルター',
    sort: '並び替え',
    actions: 'アクション',
    close: '閉じる',
    apply: '適用',
    clearAll: 'すべてクリア',
    retry: '再試行',
    select: '選択',
    selectAll: 'すべて選択',
    moreCount: '+{{count}}件',
    noData: 'データがありません',
    noResults: '該当する結果がありません',
    all: 'すべて',
    more: 'もっと見る',
    less: '閉じる',
    important: '重要',
    language: '言語',
    goHome: 'ホームへ',
    refresh: '更新',
    enabled: '有効',
    disabled: '無効',
    currentSession: '現在のセッション',
    lastActivity: '最終アクティビティ',
    expires: '有効期限',
    registeredAt: '登録日',
    lastUsed: '最終使用',
    comingSoon: '近日実装予定',
    noGroups: 'グループなし',
    unknown: '不明',
    userInfoNotAvailable: 'ユーザー情報を取得できませんでした。再度ログインしてください。',
    rowsPerPage: '表示件数',
    expand: '展開',
    collapse: '折りたたむ',
  },

  // Navigation
  navigation: {
    dashboard: 'ダッシュボード',
    documents: 'ドキュメント',
    search: '検索',
    uploadDocument: 'ドキュメントをアップロード',
    drbfm: 'DRBFM分析',
    verification: '設計検証項目',
    cadViewer: '3D CADビューア',
    settings: '設定',
    help: 'ヘルプ',
    profile: 'プロフィール',
    logout: 'ログアウト',
    toggleSidebar: 'サイドバーを切り替え',
  },

  // Dashboard
  dashboard: {
    title: 'ダッシュボード',
    totalDocuments: '総ドキュメント数',
    recentUploads: '最近のアップロード',
    totalViews: '総閲覧数',
    activeUsers: 'アクティブユーザー',
    fromLastMonth: '先月比',
    inLast7Days: '過去7日間',
    thisMonth: '今月',
    currentlyOnline: '現在オンライン',
    recentDocuments: '最近のドキュメント',
    viewAll: 'すべて表示',
    trendingSearches: 'トレンド検索',
    lastNDays: '過去{{days}}日間',
    announcements: 'お知らせ',
    noAnnouncements: '現在お知らせはありません',
    searches: '{{count}}件の検索',
    announcementAuthor: '開発チーム',
    announcementItems: {
      drbfmKnowledge: {
        title: 'DRBFM関連知識の引用表示を改善',
        message: 'DRBFMの故障モード詳細で、関連ファイルをリンク、抜粋、関連度付きで確認できます。',
      },
      chatQuality: {
        title: 'チャット検索と参照文書の品質を改善',
        message: '検索結果のまとまり、参照文書の関連度表示、根拠付き回答の安定性を改善しました。',
      },
      auditOperations: {
        title: '監査ログと運用観測を強化',
        message: '主要操作の監査ログ、異常検知、管理者向けCSVエクスポートに対応しました。',
      },
      helpRefresh: {
        title: 'ヘルプと操作ガイドを更新',
        message: '検索、チャット、DRBFM、CAD、監査機能の説明を現在の機能に合わせて整理しました。',
      },
    },
  },

  // Documents
  documents: {
    title: 'ドキュメント',
    uploadDocument: 'ドキュメントをアップロード',
    documentList: 'ドキュメント一覧',
    gridView: 'グリッド表示',
    listView: 'リスト表示',
    searchPlaceholder: 'ドキュメントを検索...',
    filters: 'フィルター',
    applyFilters: 'フィルターを適用',
    sortBy: '並び替え',
    sortOptions: {
      date: '日付',
      name: '名前',
      size: 'サイズ',
      category: 'カテゴリー',
    },
    sortOrder: {
      asc: '昇順',
      desc: '降順',
    },
    noDocumentsFound: 'ドキュメントが見つかりません',
    tryAdjustingFilters: 'フィルターや検索クエリを調整してみてください',
    generalCategory: '一般',
    deepAnalyzed: '深く分析済み',
    loadMore: 'さらに読み込む',
    resultsCount: '{{shown}} / {{total}} 件のドキュメント',
    shareDocument: 'ドキュメントを共有',
    shareComingSoon: '共有機能は現在開発中です。',

    // Document fields
    document: 'ドキュメント',
    category: 'カテゴリー',
    uploadedBy: 'アップロードユーザ',
    size: 'サイズ',
    modified: '更新日時',
    version: 'バージョン',

    // Filters
    filterBy: '絞り込み',
    categories: 'カテゴリー',
    tags: 'タグ',
    fileTypes: 'ファイルタイプ',
    dateRange: '日付範囲',
    startDate: '開始日',
    endDate: '終了日',
    activeFilters: '{{count}}個のフィルター',
    activeFilter: '{{count}}個のフィルター',

    // Document Detail Page
    details: '詳細',
    versionHistory: 'バージョン履歴',
    permissions: '権限',
    metadata: 'メタデータ',
    department: '部署',
    classification: '分類',
    retentionPeriod: '保存期間',
    lastModified: '最終更新',
    years: '年',
    actions: 'アクション',
    preview: 'プレビュー',
    loadingPreview: 'プレビューを読み込み中...',
    uploadNewVersion: '新しいバージョンをアップロード',
    failedToLoad: 'ドキュメントの読み込みに失敗しました',
    documentNotFound: 'ドキュメントが見つかりません',
    returnToDocuments: 'ドキュメント一覧に戻る',
    analysisHistory: '分析履歴',
    analysisHistoryView: {
      emptyTitle: 'このドキュメントにはまだ深い分析履歴がありません。',
      emptyDescription: 'チャットで「ドキュメントを選択し、深い分析をお願いします」と依頼すると、詳細な技術分析が記録されます。',
      title: '分析履歴 ({{count}}件)',
      type: {
        deepTechnicalAnalysis: '深い技術分析',
        summary: '要約',
        extraction: 'データ抽出',
      },
      createdBy: '作成者: {{name}}',
      showContent: '分析内容を表示',
    },
    detailTabsAria: 'ドキュメント詳細タブ',
    previewUnavailableForType: '{{type}}のプレビューは利用できません',
    previewLoadFailed: 'プレビューの読み込みに失敗しました',
    previewLoadFailedWithStatus: 'プレビューの読み込みに失敗しました: {{status}}',
    previewLoadFailedWithStatusText: 'プレビューの読み込みに失敗しました: {{status}} {{statusText}}',
    fileTypeFallback: 'このファイル形式',
    fileName: 'ファイル名',
    fileType: 'ファイル種別',
    fileSize: 'ファイルサイズ',
    status: 'ステータス',
    createdAt: '作成日',
    reExtractMetadata: 'メタデータを再抽出',
    reExtractMetadataDescription: 'LLMを使用してドキュメントからメタデータを再生成します。更新したい項目を選択してください。',
    regenerateTitle: 'タイトルを再生成',
    regenerateSummary: 'サマリーを再生成',
    regenerateTags: 'タグを再生成',
    reExtractingMetadata: 'メタデータ再抽出中...',
    selectAtLeastOneMetadataField: '少なくとも1つの項目を選択してください',
    metadataReExtractFailed: 'メタデータの再抽出に失敗しました',
    extractedImagesTitle: '抽出画像・図面',
    itemCount: '({{count}}個)',
    imageAnalysisComplete: '画像分析が完了しました',
    imageAnalysisFailed: '画像分析に失敗しました',
    imagesAnalyzed: '{{count}}個の画像を分析しました',
    imagesReanalyzed: '{{count}}個の画像を再分析しました',
    imagesExtracted: '{{count}}個の画像を抽出しました',
    blueprintImagesExtracted: '{{count}}個の図面画像を抽出しました',
    imageReExtractFailed: '画像の再抽出に失敗しました。',
    blueprintReExtractFailed: '図面画像の再抽出に失敗しました。',
    aiAnalyzing: 'AI分析中...',
    analyzeAllImages: '全画像をAI分析',
    forceReanalyze: '既存の分析結果も再分析する',
    extracting: '抽出中...',
    reExtractImages: '画像を再抽出',
    reExtractAsBlueprint: '図面として再抽出',
    imagesSelected: '{{count}}個選択中',
    selectTwoImages: '画像を2つ選択してください',
    selectAtLeastTwoImages: '2つ以上の画像を選択してください',
    sequenceAnalysisMaxImages: 'シーケンス分析は最大{{count}}個の画像まで対応しています',
    extractedImageAlt: 'Page {{page}}, Image {{index}}',
    imageLoadFailed: '画像を読み込めません',
    imageFileNotFound: 'ファイルが見つかりません',
    imagePageCaption: 'Page {{page}} - Image {{index}}',
    aiAnalysisResult: 'AI分析結果',
    analyzing: '分析中...',
    reanalyze: '再分析',
    aiAnalysis: 'AI分析',
    noExtractedImages: 'このドキュメントから抽出された画像はありません',
    documentPermissions: 'ドキュメント権限',
    versionHistoryFetchFailed: 'バージョン履歴の取得に失敗しました',
    versionHistoryLoadFailed: 'バージョン履歴の読み込みに失敗しました',
    noDescription: '説明なし',
    noVersionHistory: 'バージョン履歴がありません',
    versionWithNumber: 'バージョン {{version}}',
    versionWithCurrent: 'バージョン {{version}}（現在）',
    currentVersion: '現在',
    deepAnalysisCompleted: '深い分析実施済み',
    deepTechnicalAnalysis: '深い技術分析',
    createdBy: '作成者: {{name}}',
    compare: '比較',
    restore: '復元',
    compareWithCurrent: '現在のバージョンと比較',
    restoreThisVersion: 'このバージョンを復元',
    compareVersions: 'バージョンを比較',
    versus: 'vs',
    versionComparisonComingSoon: 'バージョン比較ビューはここに実装予定です',
    pdfLoadFailed: 'PDFドキュメントの読み込みに失敗しました',
    pdfSearchTooltip: '検索（N/Pキーで結果を移動）',
    toggleResultsList: '結果リストを切り替え',
    searchInDocument: 'ドキュメント内を検索...',
    pageResultPreview: 'Page {{page}}: {{text}}...',
    previousResultShortcut: '前へ (P)',
    nextResultShortcut: '次へ (N)',
    imageComparison: {
      title: '画像比較・連携分析',
      type: '比較タイプ',
      compareTwo: '2つを比較',
      sequenceAnalysis: 'シーケンス分析 ({{count}}個)',
      selectImagesHint: '画像を選択して比較・連携分析を開始',
      compareResultTitle: '画像比較分析結果',
      sequenceResultTitle: '画像シーケンス分析結果',
      aiAnalyzingPleaseWait: 'AI分析中...しばらくお待ちください',
      typeWithValue: '比較タイプ: {{type}}',
      resultLoadFailed: '分析結果の取得に失敗しました',
      types: {
        changes: '変更点',
        evolution: '設計進化',
        differences: '違い',
      },
    },
  },

  // File types
  fileTypes: {
    pdf: 'PDF',
    docx: 'Word文書',
    xlsx: 'Excelファイル',
    pptx: 'PowerPoint',
    other: 'その他',
  },

  // Time
  time: {
    justNow: 'たった今',
    minutesAgo: '{{count}}分前',
    hoursAgo: '{{count}}時間前',
    daysAgo: '{{count}}日前',
    weeksAgo: '{{count}}週間前',
    monthsAgo: '{{count}}ヶ月前',
    yearsAgo: '{{count}}年前',
    ago: '{{value}}前',
  },

  // Auth
  auth: {
    login: 'ログイン',
    logout: 'ログアウト',
    email: 'メールアドレス',
    password: 'パスワード',
    rememberMe: 'ログイン状態を保持',
    forgotPassword: 'パスワードをお忘れですか？',
    resetPassword: 'パスワードをリセット',
    tenantCode: 'テナントコード',
    loginError: 'ログインに失敗しました',
    invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
    // Login Page
    signInPrompt: 'アカウントにサインイン',
    signIn: 'サインイン',
    emailAddress: 'メールアドレス',
    tenantCodePlaceholder: '例: ACME',
    emailPlaceholder: 'user@example.com',
    togglePasswordVisibility: 'パスワード表示を切り替え',
    // Forgot Password Page
    forgotPasswordTitle: 'パスワードをお忘れですか？',
    forgotPasswordDescription: 'メールアドレスとテナントコードを入力してください。パスワードリセット用のリンクをお送りします。',
    sendResetLink: 'リセットリンクを送信',
    backToLogin: 'ログインに戻る',
    checkYourEmail: 'メールを確認してください',
    resetLinkSent: 'パスワードリセット用のリンクを送信しました：',
    checkSpamFolder: 'メールが届かない場合は、迷惑メールフォルダをご確認ください。',
    // Reset Password Page
    resetPasswordTitle: 'パスワードをリセット',
    resetPasswordDescription: '新しいパスワードを入力してください。',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワード（確認）',
    passwordResetSuccess: 'パスワードのリセットが完了しました',
    passwordResetSuccessMessage: 'パスワードが正常にリセットされました。新しいパスワードでサインインできます。',
    goToLogin: 'ログインへ',
    passwordsDoNotMatch: 'パスワードが一致しません',
    passwordRequirementsNotMet: 'パスワードが最低セキュリティ要件を満たしていません。',
    invalidResetToken: '無効または期限切れのリセットトークンです。新しいパスワードリセットをリクエストしてください。',
    resetLinkExpired: 'パスワードのリセットに失敗しました。リセットリンクが期限切れの可能性があります。',
    // Password requirements
    passwordRequirements: 'パスワード要件：',
    minLength: '8文字以上',
    hasUpperCase: '大文字を1つ以上',
    hasLowerCase: '小文字を1つ以上',
    hasNumber: '数字を1つ以上',
    hasSpecial: '特殊文字を1つ以上',
  },

  // Errors
  errors: {
    generic: 'エラーが発生しました',
    notFound: 'ページが見つかりません',
    pageNotFoundDescription: 'お探しのページは存在しないか、移動されました。',
    unauthorized: '権限がありません',
    forbidden: 'アクセスが拒否されました',
    serverError: 'サーバーエラーが発生しました',
    networkError: 'ネットワークエラーが発生しました',
    authenticationRequired: '認証が必要です。再度ログインしてください。',
  },

  // Success messages
  success: {
    saved: '保存しました',
    uploaded: 'アップロードしました',
    deleted: '削除しました',
    updated: '更新しました',
    shared: '共有しました',
  },

  // Confirmation
  confirmation: {
    deleteDocument: 'このドキュメントを削除してもよろしいですか？',
    unsavedChanges: '保存されていない変更があります。このまま離れてもよろしいですか？',
  },

  // Notifications
  notifications: {
    info: '情報',
    warning: '警告',
    error: 'エラー',
    success: '成功',
  },

  // Session
  session: {
    expiredDueToInactivity: '操作がなかったため、セッションの有効期限が切れました。',
    expiresSoon: '操作がないため、あと5分でセッションの有効期限が切れます。',
    expired: 'セッションの有効期限が切れました。再度ログインしてください。',
    extended: 'セッションを延長しました。',
  },

  // Pagination
  pagination: {
    page: 'ページ',
    of: 'の',
    show: '表示',
    showing: '表示中',
    to: '〜',
    items: '件',
    perPage: '件/ページ',
    perPageCount: '{{count}}件/ページ',
    first: '最初',
    previous: '前へ',
    next: '次へ',
    last: '最後',
  },

  // Upload
  upload: {
    dragDrop: 'ファイルをドラッグ＆ドロップ',
    or: 'または',
    selectFiles: 'ファイルを選択',
    uploading: 'アップロード中...',
    processing: '処理中...',
    maxSize: '最大ファイルサイズ: {{size}}',
    allowedTypes: '対応ファイル形式: {{types}}',
    duplicateCheck: '重複チェック',
    uploadProgress: 'アップロード進捗',
    overallProgress: '全体進捗',
    currentFile: '現在のファイル',
    errors: 'エラー',
    // Upload Page specific
    pageTitle: 'ドキュメントをアップロード',
    selectDocuments: 'アップロードするドキュメントを選択',
    selectDocumentsDesc: 'ファイルをここにドラッグ＆ドロップするか、クリックして参照してください。対応形式: PDF, DOCX, XLSX',
    browseFiles: 'ファイルを参照',
    selectedFiles: '選択されたファイル',
    addMetadata: 'ドキュメントメタデータを追加',
    addMetadataDesc: 'ドキュメントに関する追加情報を提供して検索性を向上させます',
    uploadProgressTitle: 'アップロード進捗',
    uploadProgressDesc: 'ドキュメントがアップロードおよび処理されています',
    uploadComplete: 'アップロード完了！',
    uploadCompleteDesc: '{{total}}件中{{completed}}件のファイルが正常にアップロードされました。',
    backgroundProcessingTitle: 'アップロード済み・AI処理中',
    backgroundProcessingMessage: 'アップロード済み。AI処理はバックグラウンドで継続中です。',
    backgroundProcessingDesc: 'AI処理はバックグラウンドで継続中です。ドキュメント一覧または詳細から後で状態を確認できます。',
    viewDocuments: 'ドキュメントを表示',
    // Steps
    steps: {
      selectFiles: 'ファイルを選択',
      addMetadata: 'メタデータを追加',
      uploadProcess: 'アップロード＆処理',
    },
    // Duplicate dialog
    duplicateDetected: '重複ファイルが検出されました',
    duplicateWarning: '同じ内容のファイルがシステムに既に存在します。',
    duplicateFileName: 'ファイル名: {{name}}',
    duplicatePrompt: '同じファイル名のドキュメントが既に存在します。どのように処理しますか？',
    uploadingFile: 'アップロードしようとしているファイル:',
    existingFileInfo: '既存のファイル情報:',
    fileName: 'ファイル名',
    fileSize: 'ファイルサイズ',
    title: 'タイトル',
    currentVersion: '現在のバージョン',
    uploadedAt: 'アップロード日時',
    newVersionInfo: '「新しいバージョンとして保存」を選択すると、既存のファイルはそのまま残り、新しいファイルはVersion {{version}} として保存されます。',
    duplicateFile: 'ファイル',
    existingDocument: '既存のドキュメント',
    cancelUpload: 'アップロードをキャンセル',
    uploadAnyway: 'そのままアップロード',
    replaceExisting: '既存を置き換え',
    saveAsSeparate: '別のファイルとして保存',
    saveAsNewVersion: '新しいバージョンとして保存',
    // Navigation
    back: '戻る',
    next: '次へ',
    duplicate: '重複',
    // Dropzone
    dropFilesHere: 'ここにファイルをドロップ',
    dragDropFiles: 'ファイルをドラッグ＆ドロップ',
    orClickToBrowse: 'またはクリックしてファイルを参照',
    maxFiles: '最大ファイル数: {{count}}',
    maxFilesError: '最大{{count}}個のファイルまでです',
    fileSizeError: '{{name}}: ファイルサイズが{{size}}MBの制限を超えています',
    fileTypeError: '{{name}}: サポートされていないファイル形式です。許可: {{types}}',
    progressTracker: {
      overallProgress: '全体進捗',
      fileProgress: 'ファイル進捗',
      completedCount: '{{count}}件完了',
      failedCount: '{{count}}件失敗',
      fileDetails: 'ファイル詳細',
      fileSize: 'ファイルサイズ:',
      fileType: 'ファイル種別:',
      progress: '進捗:',
      metadata: 'メタデータ',
      category: 'カテゴリー:',
      description: '説明:',
    },
    status: {
      pending: '待機中...',
      uploading: 'アップロード中... {{progress}}%',
      processing: '処理中...',
      completed: '完了',
      error: '失敗',
      duplicate: '重複ファイル',
      unknown: '不明',
    },
  },

  testUpload: {
    title: 'テストデータアップロード',
    description: '開発・テスト用のドキュメントを一括アップロードします。',
    incidentDirectory: 'インシデントファイルディレクトリ: /upload_data/incident file/',
    quickUpload: 'クイックアップロード',
    selectIncidentFiles: 'インシデントファイルを選択してアップロード',
    quickUploadHelp: '過去トラファイルを選択すると自動的にメタデータが設定されます。',
    detailedUpload: '詳細設定アップロード',
    category: 'カテゴリー',
    categories: {
      incident: '過去トラ',
      finance: '財務',
      planning: '企画',
      analytics: '分析',
      engineering: 'エンジニアリング',
    },
    selectFiles: 'ファイルを選択',
    selectedFiles: '選択されたファイル: {{count}}件',
    startUpload: 'アップロード開始',
    uploading: 'アップロード中...',
    results: 'アップロード結果',
    successCount: '成功: {{count}}件',
    failureCount: '失敗: {{count}}件',
    succeededFiles: '成功したファイル:',
    failedFiles: '失敗したファイル:',
    instructionsTitle: '使用方法:',
    instructions: {
      quick: '「インシデントファイルを選択してアップロード」をクリックして過去トラファイルを一括アップロード',
      detailed: 'または「詳細設定アップロード」でカテゴリーを選択してファイルをアップロード',
      metadata: 'ファイル名から自動的にメタデータが生成されます（インシデントファイルの場合）',
      review: 'アップロード完了後、ドキュメント一覧ページで確認できます',
    },
  },

  // Search
  search: {
    title: '検索',
    searchDocuments: 'ドキュメントを検索',
    advancedSearch: '詳細検索',
    searchResults: '検索結果',
    noResults: '検索結果がありません',
    errorTitle: '検索エラー',
    searchIn: '検索対象',
    matchType: 'マッチタイプ',
    exactMatch: '完全一致',
    fuzzyMatch: 'あいまい検索',
    suggestions: '検索候補',
    relatedDocuments: '関連ドキュメント',
    searchHistory: '検索履歴',
    savedSearches: '保存された検索',
    // Search Page specific
    searchPlaceholder: 'ドキュメント、レポート、プレゼンテーションを検索...',
    filters: 'フィルター',
    searchType: '検索タイプ',
    searchTypes: {
      basic: '基本検索',
      semantic: 'セマンティック検索',
      exact: '完全一致',
    },
    sortOptions: '並び替えオプション',
    sortBy: '並び替え',
    sortValues: {
      relevance: '関連度',
      title: 'タイトル',
    },
    order: '順序',
    sortOrder: {
      desc: '降順',
      asc: '昇順',
    },
    active: '有効',
    activeFilters: '有効なフィルター',
    noDocumentsMatch: '「{{query}}」に一致するドキュメントはありません',
    adjustTermsOrFilters: '検索語句またはフィルターを調整してください',
    resultsSummary: '{{total}}件の結果',
    resultsSummaryForQuery: '「{{query}}」の結果 {{total}}件',
    searchTime: '({{time}}秒)',
  },

  integrationNotice: {
    title: 'Azure連携ステータス',
    features: {
      authentication: '認証',
      fileUpload: 'ファイルアップロード',
      documentSearch: 'ドキュメント検索',
      documentList: 'ドキュメント一覧',
      documentDetails: 'ドキュメント詳細',
    },
    descriptions: {
      authentication: 'モック認証を使用中です（バックエンド認証は未実装）',
      fileUpload: 'Azure Document Intelligenceと連携済みです',
      documentSearch: 'Azure AI Searchと連携済みです',
      backendPending: 'バックエンドAPIはまだ利用できません',
    },
    noteLabel: '注:',
    note: 'ファイルアップロードと検索機能をテストできます。ドキュメント一覧と詳細にはバックエンド実装が必要です。',
  },

  // Permissions
  permissions: {
    read: '閲覧',
    write: '編集',
    view: '閲覧',
    edit: '編集',
    delete: '削除',
    share: '共有',
    admin: '管理者',
    owner: '所有者',
    public: '公開',
    private: 'プライベート',
    restricted: '制限付き',
    loadFailed: '権限の読み込みに失敗しました',
    manageDescription: 'このドキュメントにアクセスできるユーザーと実行可能な操作を管理します。',
    addPermission: '権限を追加',
    editPermission: '権限を編集',
    noPermissions: '権限が設定されていません',
    noPermissionsDescription: '「権限を追加」からユーザーまたはグループにアクセス権を付与できます',
    entity: '対象',
    type: 'タイプ',
    grantedBy: '付与者',
    grantedDate: '付与日',
    entityType: '対象タイプ',
    selectEntity: '{{type}}を選択',
    readDescription: '閲覧 - ドキュメントを表示できます',
    writeDescription: '編集 - ドキュメントを編集できます',
    shareDescription: '共有 - 他のユーザーに共有できます',
    deleteDescription: '削除 - ドキュメントを削除できます',
    types: {
      user: 'ユーザー',
      group: 'グループ',
      tenant: 'テナント',
    },
  },

  // Categories (matching database migration 008 codes)
  categories: {
    incident: '過去トラ',
    design_standard: '設計基準書',
    technical_specs: '技術仕様書',
    operation_manuals: '運用手順書',
    drawing: '図面',
    planning: '企画',
    analytics: '分析',
    other: 'その他',
    incidentDesc: '過去のトラブル・不具合報告書',
    design_standardDesc: '設計基準・設計指針に関する文書',
    technical_specsDesc: '技術的な仕様や要件を記載した文書',
    operation_manualsDesc: 'システムや製品の運用手順書',
    drawingDesc: '技術図面・設計図',
    planningDesc: '企画書・提案書',
    analyticsDesc: '分析レポート・調査報告',
    otherDesc: 'その他の文書',
  },

  // Document Metadata Form
  metadata: {
    basicInformation: '基本情報',
    category: 'カテゴリー',
    categoryRequired: 'カテゴリーは必須です',
    description: '説明',
    descriptionRequired: '説明は必須です',
    descriptionHelp: 'ドキュメントの内容について簡単に説明してください',
    department: '部署',
    none: 'なし',
    tags: 'タグ',
    tagsPlaceholder: '検索性を向上させるためのタグを追加',
    tagsHelp: '候補から選択するか、カスタムタグを入力してください',
    addCustomTag: 'カスタムタグを追加',
    add: '追加',
    classificationSecurity: '分類とセキュリティ',
    classification: '分類',
    public: '公開',
    publicDesc: '組織外で共有可能',
    internal: '社内',
    internalDesc: '社内使用限定',
    confidential: '機密',
    confidentialDesc: 'アクセス制限あり',
    defaultAccessLevel: 'デフォルトアクセスレベル',
    privateOnly: 'プライベート（自分のみ）',
    teamDepartment: 'チーム（部署内）',
    organizationEveryone: '組織（全員）',
    allowShare: '他のユーザーがこのドキュメントを共有できるようにする',
    allowDownload: '他のユーザーがこのドキュメントをダウンロードできるようにする',
    continueToUpload: 'アップロードを続行',
    metadataNote: 'このメタデータは選択された{{count}}個の{{files}}に適用されます。',
    file: 'ファイル',
    files: 'ファイル',
  },

  // Departments
  departments: {
    finance: '財務',
    marketing: 'マーケティング',
    engineering: 'エンジニアリング',
    humanResources: '人事',
    sales: '営業',
    operations: 'オペレーション',
    legal: '法務',
    executive: '経営',
  },

  // Admin
  admin: {
    title: '管理',
    description: 'システム設定、ユーザー、アクティビティを管理します。',
    users: 'ユーザー管理',
    usersDescription: 'ユーザー、ロール、権限を管理',
    groups: 'グループ管理',
    categories: 'カテゴリー管理',
    tags: 'タグ管理',
    permissions: '権限管理',
    auditLogs: '監査ログ',
    auditLogsDescription: 'システム監査ログを表示',
    settings: 'システム設定',
    settingsDescription: 'システム全体の設定を構成',
    systemHealth: 'システム状態',
    storage: 'ストレージ管理',
    storageDescription: 'ストレージ使用量と割り当てを監視',
    security: 'セキュリティ',
    securityDescription: 'セキュリティ設定とアクセス制御',
    analytics: '分析',
    analyticsDescription: 'システム使用状況の分析とレポート',
    activityAudit: 'アクティビティ監査',
    activityAuditDescription: 'テナントの全ユーザーアクティビティをダッシュボードで確認 (#579)',
    anomalies: '不審行為一覧',
    anomaliesDescription: '連続ログイン失敗・テナント越境などの不審シグナルを確認 (#578)',
    noPermission: '管理機能へのアクセス権限がありません。',
  },

  // Settings
  settings: {
    title: '設定',
    description: 'アプリケーションの表示設定や通知設定をカスタマイズします',
    appearance: '表示設定',
    theme: 'テーマ',
    themeLight: 'ライト',
    themeDark: 'ダーク',
    language: '言語設定',
    selectLanguage: '表示言語',
    languageOptions: {
      japanese: '日本語',
      english: 'English',
    },
    notifications: '通知設定',
    enableNotifications: 'アプリ内通知を有効にする',
    emailNotifications: 'メール通知を受け取る',
    notificationNote: '通知設定はブラウザに保存されます。',
    activityTitle: 'アクティビティ・監査ログ',
    activityDescription: 'ログイン、ドキュメント、チャット、CAD、DRBFM などテナント内の操作履歴を確認できます（manager 以上）。',
    openActivityDashboard: 'アクティビティ ダッシュボードを開く',
    openAnomalyTriage: '異常検知イベントを確認する',
    systemTitle: 'システム設定',
    systemDescription: 'システムの設定と管理を行います',
    searchSettings: '検索設定',
    tenantSettingsFetchFailed: 'テナント設定の取得に失敗しました',
    keywordMatching: 'キーワードマッチ処理',
    keywordMatchingTooltip: 'ONの場合、検索クエリを前処理して同義語展開・キーワード抽出を行います。OFFの場合、セマンティック検索（AIによる意味理解）のみを使用します。',
    keywordMatchingEnabled: 'キーワードマッチを有効にしました',
    keywordMatchingDisabled: 'キーワードマッチを無効にしました（セマンティック検索のみ使用）',
    keywordMatchingEnabledDescription: '有効: クエリを前処理し、同義語展開・キーワード抽出を行います',
    keywordMatchingDisabledDescription: '無効: セマンティック検索（RAG）のみを使用します',
    updateFailed: '設定の更新に失敗しました',
    adminRequired: 'この設定を変更するには管理者権限が必要です',
    searchModesTitle: '検索モードについて',
    keywordMatchOnLabel: 'キーワードマッチON',
    keywordMatchOnDescription: '入力された検索文を解析し、同義語の展開やキーワード抽出を行ってから検索します。特定の用語や製品名での検索に適しています。',
    keywordMatchOffLabel: 'キーワードマッチOFF',
    keywordMatchOffDescription: 'AIが検索文の意味を直接理解し、セマンティック検索を行います。自然な質問文での検索に適しています。',
    dataManagement: 'データ管理',
    currentStatus: '現在の状態',
    registeredDocuments: '• 登録ドキュメント数: {{count}}件',
    defaultBackup: '• デフォルトバックアップ: {{status}}',
    available: '利用可能',
    unavailable: '利用不可',
    dataResetTitle: 'データリセット機能について',
    dataResetDescription: 'この機能は、ドキュメントメタデータを保存されたデフォルト状態に復元します。現在アップロードされているすべてのドキュメント情報が、バックアップされた状態に戻ります。',
    warningLabel: '注意',
    dataResetWarning: 'この操作は元に戻せません。現在のデータはバックアップされた状態に上書きされます。',
    resetToDefault: 'デフォルト状態にリセット',
    resetting: 'リセット中...',
    resetComplete: '✓ リセット完了: {{count}}件のドキュメントを復元しました',
    resetFailed: 'リセットに失敗しました',
    resetError: 'エラー: {{message}}',
    resetConfirmTitle: 'データリセットの確認',
    resetConfirmQuestion: '本当にデータをデフォルト状態にリセットしますか？',
    resetConfirmDescription: 'この操作により、現在のドキュメントメタデータがバックアップされた状態に復元されます。',
    irreversible: 'この操作は元に戻せません。',
    executeReset: 'リセットを実行',
  },

  // Audit
  audit: {
    title: 'アクティビティ監査',
    period: '期間',
    totalEvents: '総イベント数',
    activeUsers: 'アクティブユーザー',
    totalAnomalies: '不審行為(累計)',
    unresolvedAnomalies: '未解決の不審行為',
    eventsByCategory: 'カテゴリ別イベント',
    recentEvents: '最近のイベント',
    categoryAll: 'カテゴリ: すべて',
    time: '時刻',
    action: 'アクション',
    result: '結果',
    user: 'ユーザー',
    resource: 'リソース',
    durationMs: '所要時間 (ms)',
    noMatchingEvents: '該当するイベントがありません',
    summaryFetchFailed: 'サマリ取得に失敗: {{message}}',
    eventsFetchFailed: 'イベント取得に失敗: {{message}}',
    csvExportFailed: 'CSVエクスポート失敗: {{message}}',
    results: {
      all: 'すべて',
      success: 'success',
      failure: 'failure',
      error: 'error',
    },
  },

  // Anomalies
  anomalies: {
    title: '不審行為一覧',
    severity: '重要度',
    status: '状態',
    type: '種別',
    path: 'パス',
    resolved: '解決済',
    unresolved: '未解決',
    markResolved: '解決済みにする',
    noMatchingAnomalies: '該当する不審行為はありません',
    resolveDialogTitle: '不審行為を解決にする',
    resolveNote: '解決メモ (任意)',
    totalCount: '合計 {{total}} 件',
    fetchFailed: '不審行為一覧の取得に失敗: {{message}}',
    resolveFailed: '解決マークに失敗: {{message}}',
    severityValues: {
      low: 'low',
      medium: 'medium',
      high: 'high',
      critical: 'critical',
    },
  },

  // CAD Viewer
  cad: {
    title: '3D CADビューア',
    prototype: 'プロトタイプ',
    disabled: 'この機能は現在の環境では無効になっています。管理者にお問い合わせください。',
    loadModelsFailed: 'モデル一覧の取得に失敗しました',
    comparisonFailed: '比較に失敗しました: {{message}}',
    deleteFailed: '削除に失敗しました',
    drbfmLoading: 'DRBFM結果を読み込み中...',
    drbfmLoadFailed: 'DRBFM結果取得失敗: {{message}}',
    drbfmLinked: 'DRBFM セッション連携中: {{shown}} / {{total}} 件のマーカーを表示',
    drbfmNoMatchingModel: 'DRBFM セッションに紐づくCADモデルが選択されていません ({{total}} 件のマーカーは別モデル)',
    uploadedModels: 'アップロード済み ({{count}})',
    comparisonTarget: '比較対象',
    comparing: '比較中...',
    startComparison: '比較開始',
    comparisonMode: '比較モード',
    confidenceLabel: '信頼度: {{value}}',
    exitComparisonMode: '比較モードを終了',
    metadataTab: 'メタデータ',
    aiAnalysisTab: 'AI分析',
    chatTab: 'チャット',
    deleteDialogTitle: 'モデルの削除',
    deleteDialogBody: 'このCADモデルとすべての関連ファイルを削除しますか？',
    modelList: {
      emptyTitle: 'モデルなし',
      emptyDescription: 'CADファイルをアップロードしてください',
      setComparisonTarget: '比較対象に設定',
      delete: '削除',
    },
    modelSelect: {
      label: 'CADモデル',
      none: 'CADモデルを選択しない',
      empty: '解析済みCADモデルがありません',
      loadFailed: 'CADモデル一覧の取得に失敗しました',
    },
    upload: {
      dropLabel: 'CADファイルをドラッグ＆ドロップ',
      processing: '処理中... {{progress}}%',
      unsupportedFormat: '非対応のファイル形式です: {{extension}}\n対応形式: {{formats}}',
      fileTooLarge: 'ファイルサイズが100MBを超えています',
      failed: 'アップロードに失敗しました',
    },
    viewer: {
      selectModel: 'モデルを選択してください',
      loadFailed: '3Dモデルの読み込みに失敗しました',
      retry: '再試行',
      loading: '読み込み中...',
      hideGrid: 'グリッド非表示',
      showGrid: 'グリッド表示',
      showSolid: 'ソリッド表示',
      showWireframe: 'ワイヤフレーム表示',
      fit: 'フィット',
      reset: 'リセット',
    },
    chat: {
      selectModel: 'モデルを選択してチャットを開始',
      guidance: 'CADモデルについて質問できます',
      sampleSize: 'この部品のサイズ感は？',
      sampleManufacturing: '製造方法の提案は？',
      sampleQuality: '品質チェックポイントは？',
      placeholder: '質問を入力...',
      error: 'エラーが発生しました。もう一度お試しください。',
      threadCompareTitle: '[3DCAD] 比較: {{modelA}} vs {{modelB}}',
      threadTitle: '[3DCAD] {{model}}',
    },
    ai: {
      selectModel: 'モデルを選択してください',
      title: 'AI分析',
      analyzing: '分析中...',
      reanalyze: '再分析',
      start: '分析開始',
      description: 'GPT-4による設計・製造観点の分析を実行します',
      failed: 'AI分析に失敗しました',
    },
    marker: {
      source: {
        pre_label: '事前ラベル',
        hotspot: '解析ホットスポット',
        llm_inferred: 'LLM推定',
      },
    },
    markerDetail: {
      title: '失敗モード詳細',
      noData: 'この位置に紐づくDRBFMデータがありません。',
      confidence: '信頼度 {{value}}%',
      cause: '原因',
      effect: '影響',
      part: '部位',
      locationEvidence: '位置紐づけ根拠',
      relatedDocuments: '関連技術文書',
    },
    metadata: {
      empty: 'メタデータなし',
      title: 'メタデータ',
      dimensions: '寸法',
      boundingBox: 'バウンディングボックス',
      volume: '体積',
      surfaceArea: '表面積',
      geometry: '形状',
      triangleCount: '三角形数',
      vertexCount: '頂点数',
      edgeCount: 'エッジ数',
      faceCount: '面数',
      file: 'ファイル',
      originalFormat: '元フォーマット',
      originalFileSize: '元ファイルサイズ',
      glbSize: 'GLBサイズ',
      nonWatertightMesh: '非水密メッシュ',
      wallThickness: '壁厚分析',
      confidence: {
        high: '高信頼',
        medium: '近似値',
        low: '低信頼',
      },
      min: '最小',
      median: '中央値',
      mean: '平均',
      max: '最大',
      thinAreas: '薄肉箇所',
      detectedCount: '{{count}}件検出',
      meshQuality: 'メッシュ品質',
      watertight: '水密性',
      yes: 'あり',
      no: 'なし',
      bodyCount: 'ボディ数',
      degenerateFaces: '退化面',
      draftRisk: '抜き勾配リスク',
      undercutFraction: 'アンダーカット率',
      riskRegionCount: 'リスク領域数',
      count: '{{count}}件',
      pullDirection: '抜き方向',
      analysisScope: '解析スコープ',
      target: '対象',
    },
  },

  // DRBFM (Design Review Based on Failure Mode)
  drbfm: {
    title: 'DRBFM分析',
    description: '設計変更に基づく故障モード分析を実施します',
    newAnalysis: '新規分析',
    sessionHistory: '分析履歴',
    // Wizard steps
    steps: {
      input: '入力',
      processing: '処理中',
      results: '結果',
    },
    // Input form
    input: {
      title: '分析データ入力',
      description: '設計変更の対象となる部品名と、旧仕様書・新仕様書の内容を入力してください。',
      basicInfo: '基本情報',
      itemName: '部品名',
      itemNamePlaceholder: '例: ブレーキパッド、ECU基板',
      itemNameHelper: '分析対象の部品名を入力してください',
      analysisTitle: '分析タイトル',
      analysisTitlePlaceholder: '例: 2024年モデル仕様変更分析',
      analysisTitleHelper: '任意で分析タイトルを設定できます',
      specifications: '仕様書',
      specificationsHelp: '旧仕様書と新仕様書の内容を入力してください。テキストを直接入力するか、ファイルから読み込むことができます。',
      oldSpecification: '旧仕様書',
      oldSpecPlaceholder: '旧仕様書の内容をここに入力...\n\n例:\n材質: SUS304\n厚さ: 2.0mm\n表面処理: 無\n公差: ±0.1mm',
      newSpecification: '新仕様書',
      newSpecPlaceholder: '新仕様書の内容をここに入力...\n\n例:\n材質: SUS316L\n厚さ: 1.8mm\n表面処理: Niメッキ\n公差: ±0.05mm',
      selectDocument: 'ドキュメントから選択',
      loadFromDocument: 'ドキュメントから読み込み',
      startAnalysis: '分析開始',
      starting: '分析を開始中...',
      analysisInfo: 'AIが仕様書を比較し、変更点を抽出して故障モード分析を行います。分析には数分かかる場合があります。',
      // Input mode tabs
      documentMode: 'ドキュメント選択',
      textMode: 'テキスト入力',
      selectOldSpec: '旧仕様書を選択',
      selectNewSpec: '新仕様書を選択',
    },
    // Document selector
    documentSelector: {
      selectDocument: 'ドキュメントを選択',
      searchPlaceholder: 'ドキュメントを検索...',
      selected: '選択済み',
      change: '変更',
      fetchError: 'ドキュメント一覧の取得に失敗しました',
      contentError: 'ドキュメントの内容を取得できませんでした',
      noResults: '検索結果がありません',
      noDocuments: 'ドキュメントがありません',
      loadingContent: 'コンテンツを読み込み中...',
      documentSelected: 'ドキュメント選択済み',
    },
    // History page
    history: {
      title: 'DRBFM分析履歴',
      noSessions: '分析履歴がありません',
      newAnalysis: '新規分析',
      startFirst: '最初の分析を始める',
      columnItem: '対象部品',
      columnTitle: 'タイトル',
      columnAnalysis: '分析対象',
      columnStatus: 'ステータス',
      columnCreated: '作成日時',
      columnCompleted: '完了日時',
      columnActions: '操作',
      viewResults: '結果を表示',
      view3D: '3Dで見る',
      export: 'エクスポート',
      delete: '削除',
      deleteTitle: '分析結果を削除',
      deleteConfirm: '「{{itemName}}」の分析結果を削除してもよろしいですか？この操作は取り消せません。',
      exportError: 'エクスポートに失敗しました',
      statusCompleted: '完了',
      statusProcessing: '処理中',
      statusFailed: '失敗',
      statusDraft: '下書き',
      preview: 'プレビュー',
      exportExcel: 'Excel出力',
      previewTitle: 'DRBFM分析結果プレビュー',
      previewFrameTitle: 'DRBFMプレビュー',
      previewError: 'プレビューの読み込みに失敗しました',
      resultsFetchFailed: 'DRBFM結果の取得に失敗しました',
    },
    // Processing
    processing: {
      title: '分析処理中',
      description: 'AIが設計変更を分析しています。完了までお待ちください。',
      analyzing: '分析中...',
      pleaseWait: 'しばらくお待ちください',
      overallProgress: '全体進捗',
      flowStatus: 'フロー状態',
      progressLog: '進捗ログ',
      creatingSession: 'セッションを作成中...',
      flow1: {
        title: '変更点抽出',
        description: '旧仕様書と新仕様書を比較して変更点を抽出します',
      },
      flow2: {
        title: '知識ベース検索',
        description: '過去トラブルや設計基準書から関連情報を検索します',
      },
      flow3: {
        title: '故障モード分析',
        description: '変更点に関連する潜在的な故障モードを特定します',
      },
      flow4: {
        title: '対策案生成',
        description: '故障モードに対する効果的な対策案を生成します',
      },
      flow5: {
        title: 'レポート生成',
        description: 'DRBFMテーブルとレポートを生成します',
      },
      pending: '待機中',
      inProgress: '処理中',
      completed: '完了',
      failed: '失敗',
      cancel: '分析をキャンセル',
    },
    // Results
    results: {
      title: '分析結果',
      description: 'DRBFM分析結果の詳細を確認できます。',
      summary: 'サマリー',
      designChanges: '変更点',
      failureModes: '故障モード',
      countermeasures: '対策案',
      exportHTML: 'HTMLでエクスポート',
      exportPDF: 'PDFでエクスポート',
      export: 'エクスポート',
      exporting: 'エクスポート中...',
      newAnalysis: '新規分析',
      startNew: '新規分析を開始',
      backToInput: '入力画面に戻る',
      noResults: '分析結果がありません',
      tabsAria: 'DRBFM結果タブ',
    },
    // Export dialog
    export: {
      dialogTitle: '分析結果のエクスポート',
      sessionLabel: 'セッション',
      selectFormat: 'エクスポート形式を選択',
      formatHtml: 'HTML形式',
      formatHtmlDesc: 'ブラウザで表示可能なHTMLファイル',
      formatPdf: 'PDF形式',
      formatPdfDesc: '印刷・共有に適したPDFファイル',
      formatExcel: 'Excel形式',
      formatExcelDesc: 'データ分析用のExcelファイル',
      exporting: 'エクスポート中...',
      download: 'ダウンロード',
    },
    // Statistics
    stats: {
      designChanges: '変更点',
      failureModes: '故障モード',
      countermeasures: '対策案',
      critical: '重大: {{count}}件',
      highPriority: '高優先: {{count}}件',
      criticalRisks: '重大リスク',
      preventionActions: '予防対策',
      detectionActions: '検出対策',
      mitigationActions: '軽減対策',
    },
    // Status
    status: {
      draft: '下書き',
      analyzing: '分析中',
      completed: '完了',
      failed: '失敗',
      pending: '待機中',
      inProgress: '処理中',
    },
    // Table headers
    table: {
      category: 'カテゴリ',
      item: '項目',
      itemName: '項目名',
      oldSpec: '旧仕様',
      newSpec: '新仕様',
      specifications: '仕様比較',
      change: '変更内容',
      changeDescription: '変更内容',
      impact: '影響範囲',
      impactAreas: '影響範囲',
      failureMode: '故障モード',
      failureDescription: '故障モード',
      cause: '原因',
      failureCause: '原因',
      effect: '影響',
      failureEffect: '影響',
      severity: '重大度',
      severityScore: 'スコア',
      rpn: 'RPN',
      rpnScore: 'RPN',
      countermeasure: '対策',
      countermeasureType: '対策タイプ',
      type: 'タイプ',
      description: '説明',
      effectiveness: '有効性',
      priority: '優先度',
      reference: '参照情報',
      designChanges: '変更点',
      failureModes: '故障モード',
      countermeasures: '対策案',
      noData: 'データがありません',
    },
    // Severity levels
    severity: {
      critical: '重大',
      high: '高',
      medium: '中',
      low: '低',
    },
    // Countermeasure types
    countermeasureType: {
      prevention: '予防',
      detection: '検出',
      mitigation: '軽減',
    },
    // Categories
    category: {
      Material: '材料',
      Dimension: '寸法',
      Process: '工程',
      Structure: '構造',
      Surface: '表面',
      Tolerance: '公差',
      Function: '機能',
      Other: 'その他',
    },
    // Impact areas
    impactArea: {
      Design: '設計',
      Manufacturing: '製造',
      Quality: '品質',
      Safety: '安全性',
      Cost: 'コスト',
      Maintenance: '保守',
    },
    // Session list
    sessions: {
      title: '分析セッション一覧',
      noSessions: '分析セッションがありません',
      createFirst: '最初の分析を開始してください',
      loadMore: 'もっと読み込む',
      delete: '削除',
      deleteConfirm: 'このセッションを削除してもよろしいですか？',
      view: '詳細を表示',
      resume: '再開',
    },
    // Errors
    errors: {
      createFailed: 'セッションの作成に失敗しました',
      analysisFailed: '分析に失敗しました',
      loadFailed: 'データの読み込みに失敗しました',
      exportFailed: 'エクスポートに失敗しました',
      connectionLost: '接続が切断されました。再試行してください',
      itemNameRequired: '部品名は必須です',
      oldSpecRequired: '旧仕様書は必須です',
      newSpecRequired: '新仕様書は必須です',
      sessionLoadFailed: 'セッションの読み込みに失敗しました',
      cadLinkFailed: 'CADリンクに失敗しました',
    },
    // Success messages
    success: {
      analysisComplete: '分析が完了しました',
      exported: 'エクスポートが完了しました',
      sessionDeleted: 'セッションを削除しました',
    },
    // Knowledge references
    knowledge: {
      title: '参照知識',
      references: '関連知識',
      document: 'ドキュメント',
      relevance: '関連度',
      snippet: '抜粋',
      noReferences: '関連する知識が見つかりませんでした',
    },
    // Chat integration
    chat: {
      triggerTitle: 'DRBFM分析',
      triggerDescription: 'チャットからDRBFM分析を開始できます。分析対象の部品名を入力してください。',
      selectedDocument: '選択されたドキュメント',
      openFullPage: '詳細ページを開く',
      startAnalysis: '分析を開始',
      resultTitle: 'DRBFM分析結果',
      viewDetails: '詳細を表示',
    },
    // Validation messages
    validation: {
      itemNameRequired: '部品名を入力してください',
    },
    case: {
      title: 'GDSケース作成',
      description: '図面ページとGDS移管時の変更概要を起点にDRBFMケースを作成します。',
      startCase: 'GDSケースで開始',
      normalMode: '通常DRBFMへ',
      referenceDrawing: '参照図面: {{page}}ページ目',
      documentId: '文書ID {{id}}',
      imageId: '画像ID {{id}}',
      fields: {
        title: 'ケースタイトル',
        productName: '製品',
        targetPart: '対象部品',
        changeSummary: '変更概要',
      },
      required: '{{field}}は必須です',
      extractChanges: '変更点を抽出',
      extractingChanges: '変更点を抽出中',
      reviewTitle: '変更点レビュー',
      reviewDescription: '抽出された技術変更点をDRBFM入力として整えます。',
      noChanges: '抽出された変更点はありません。',
      changeNumber: '変更点 {{number}}',
      confidence: '信頼度 {{value}}%',
      changedItem: '変更項目',
      oldSpecification: '旧仕様',
      newSpecification: '新仕様',
      technicalChange: '技術変更内容',
      backToConditions: 'ケース条件に戻る',
      generatingPrecheck: '事前確認を生成中',
      continueToPrecheck: '事前確認へ進む',
      precheckTitle: '事前確認',
      precheckDescription: '不明点を明示してからDRBFM分析へ進みます。',
      noPrecheckItems: '事前確認項目はありません。',
      answer: '回答',
      answerHelper: '入力すると回答済みになります',
      backToChangeReview: '変更点レビューに戻る',
      generatingDrbfm: 'DRBFM生成中',
      generateDrbfm: 'DRBFMを生成',
      answerRequired: 'すべての確認項目に回答するか、不明または該当なしを選択してください。',
      refetching: '再取得中',
      refetchResults: '結果を再取得',
      analyzingLabel: 'DRBFMケース分析中',
      exportMissing: 'エクスポート対象のDRBFM結果がありません',
      exportFailed: 'HTMLエクスポートに失敗しました',
      missingCase: 'ケースが作成されていません',
      missingAnalysisSession: '分析セッションが作成されていません',
      createCaseFailed: 'ケースの作成に失敗しました',
      generatePrecheckFailed: '事前確認の生成に失敗しました',
      fetchResultsFailed: '分析結果の取得に失敗しました',
      analyzeFailed: '分析に失敗しました',
      answerStatus: {
        unanswered: '未回答',
        answered: '回答済み',
        unknown: '不明',
        not_applicable: '該当なし',
      },
    },
    drawingEvidence: {
      title: '図面根拠',
      missingDocumentId: '図面根拠の文書IDがありません。',
      imageNotFound: '対象ページの画像が見つかりません。',
      imageLoadFailed: '図面画像を読み込めませんでした。',
      notLinked: '図面根拠はまだ紐付いていません。',
      openDocumentPage: '文書ページを開く',
      goToDocument: '文書へ',
      missingNormalizedBbox: '正規化されたbboxがないため、文書ページで根拠箇所を確認してください。',
    },
    decisionMemory: {
      title: '設計判断メモリ',
      selectFailureMode: '故障モードを選択してください。',
      severity: '重大度 {{value}}',
      evidenceAvailable: '根拠あり',
      drawingLinked: '図面リンク済み',
      questionsGenerated: '質問生成',
      knowledgeLinked: '関連知識と照合済み',
      knowledgeUnlinked: '関連知識は未紐付け',
      additionalReviewNeeded: '追加確認が必要',
      noAdditionalQuestions: '追加質問なし',
      reviewComment: '{{description}}はRPN {{rpn}}。{{evidenceText}}、{{questionText}}としてレビューしてください。',
      followUpQuestions: 'AI追加確認質問',
      usedPrecheckAnswers: '事前確認で使った回答',
      unresolvedAssumptions: '未確定の前提',
      relatedKnowledgeSummary: '関連知識サマリー',
      relevance: '関連度 {{value}}',
      confidence: '信頼度 {{value}}',
      confirmInDrawing: '図面で確認',
    },
    cadLink: {
      parseError: '部位ラベルJSONを読み取れません',
      inputHelper: 'CADモデルを選ぶと、DRBFM解析完了後に3D上の該当部位へ自動リンクします',
      partLabelsJson: '部位ラベルJSON',
      partLabelsHelper: 'cover_part_labels.json全体、またはparts配列を貼り付けると優先ラベルとして使います',
      bulkView: '3Dで一括表示',
      unlinkedCount: '未リンクの失敗モードが{{count}}件あります。',
      partialResolved: 'CADリンクは一部未解決です: {{linked}}件リンク、{{unresolved}}件未解決',
      noLinks: 'このDRBFM結果にはまだCADリンクがありません。',
      linkHelper: '選択したCADモデルに失敗モードをリンクします',
      linking: 'リンク中...',
      link: 'CADにリンク',
      view3DTooltip: '3Dビューアで該当部位を表示',
      view3DUnavailable: 'CADモデルが紐付いていない、またはセッションIDが未指定',
      view3DLabel: '3Dで見る',
      selectFailureModeLabel: '故障モードを選択: {{description}}',
      designChangeExpand: '設計変更詳細を開く',
      designChangeCollapse: '設計変更詳細を閉じる',
      failureModeExpand: '故障モード詳細を開く',
      failureModeCollapse: '故障モード詳細を閉じる',
    },
    // Convert to verification
    convert: {
      dialogTitle: '検証項目に変換',
      buttonLabel: '検証項目に変換',
      steps: {
        selectFailureModes: '故障モード選択',
        chooseTarget: '追加先を選択',
        preview: 'プレビュー',
      },
      classifications: {
        performance: '性能',
        function: '機能',
        reliability: '信頼性',
        safety: '安全性',
        cost: 'コスト',
        maintenance: '保守',
      },
      methods: {
        analysis: '解析',
        pre_test: '事前テスト',
        actual_confirm: '実機確認',
        dr1: 'DR1',
        design_calc: '設計計算',
        knowhow: 'ノウハウ',
      },
      fetchSessionsFailed: '検証セッション一覧の取得に失敗しました',
      convertFailed: '検証項目への変換に失敗しました',
      defaultSessionTitle: 'DRBFM連携: {{itemName}}',
      selectFailureModesDescription: '変換対象の故障モードを選択してください（{{selected}}/{{total}}件選択中）',
      selectAll: '全選択',
      deselectAll: '全解除',
      existingSession: '既存セッションに追加',
      verificationSession: '検証セッション',
      unit: 'ユニット',
      createNewUnit: '新規ユニット作成',
      newSession: '新規セッション作成',
      sessionTitle: 'セッションタイトル',
      modelName: '機種名',
      modelNamePlaceholder: '例: VARIAXIS i-800 NEO',
      unitNumber: 'ユニット番号',
      unitName: 'ユニット名',
      previewDescription: '以下の{{count}}件の検証項目が生成されます。',
      itemName: '項目名',
      classification: '分類',
      standardTarget: '基準・目標',
      verificationMethod: '検証手法',
      destination: '追加先:',
      destinationNew: '新規セッション「{{title}}」',
      destinationExisting: '既存セッション「{{title}}」',
      successTitle: '{{count}}件の検証項目を追加しました',
      successDescription: 'DRBFM分析結果からの検証項目変換が完了しました。',
      viewVerificationItems: '検証項目一覧を表示',
      back: '戻る',
      next: '次へ',
      submitting: '変換中...',
      submit: '検証項目に追加',
    },
  },

  // Design Verification Items List (設計検証項目一覧)
  verification: {
    title: '設計検証項目一覧',
    description: '設計検証項目の管理とExcel帳票出力',
    units: 'ユニット',
    items: '項目',
    modelName: '機種名',
    sessionTitle: 'セッションタイトル',
    sessionDescription: '説明',
    selectSession: 'セッションを選択してください',
    noUnits: 'ユニットがありません',
    addUnit: 'ユニット追加',
    editUnit: 'ユニット編集',
    deleteUnit: 'ユニット削除',
    addItem: '項目追加',
    editItem: '項目編集',
    unitNumber: 'ユニット番号',
    unitNameLabel: 'ユニット名',
    primary: '主',
    secondary: '副',
    right: '右',
    reviewRequired: '要',
    reviewNotRequired: '否',
    standardTargetHelp: '基準・目標値を入力してください（最重要項目）',
    classificationLabels: {
      performance: '性能',
      function: '機能',
      reliability: '信頼・耐久性',
      safety: '安全性',
      cost: 'コスト',
      maintenance: '保守',
    },
    methodLabels: {
      unit_prototype: 'ユニット試作',
      pre_test: '事前テスト',
      design_calc: '設計計算',
      competitor_comp: '他社比較',
      analysis: '解析',
      dr1: 'DR1',
      knowhow: 'ノウハウ',
      actual_confirm: '実機確認',
    },
    sessionCreated: 'セッションを作成しました',
    unitAdded: 'ユニットを追加しました',
    itemAdded: '項目を追加しました',
    deleteConfirmTitle: '削除の確認',
    deleteConfirmMessage: 'この操作は取り消せません。削除してもよろしいですか？',
    chat: {
      title: 'AI検証チャット',
      openTooltip: 'AI検証チャット',
      closeTooltip: 'チャットを閉じる',
    },
    sessions: {
      title: '検証セッション一覧',
      noSessions: '検証セッションがありません',
      create: '新規セッション作成',
    },
    table: {
      unit: '大分類ユニット',
      specification: '仕様',
      itemName: '項目',
      classification: '分類',
      standardTarget: '基準・目標',
      verificationMethod: '検証方法',
      review: '審査',
      qualityRecordNo: '品質記録書NO.',
      qualityRecordTitle: '品質記録書タイトル',
    },
    export: {
      dialogTitle: 'Excel出力',
      excel: 'Excel出力',
      sessionLabel: 'セッション',
      download: 'ダウンロード',
      exporting: 'エクスポート中...',
      error: 'エクスポートに失敗しました',
    },
    drbfmLink: 'この項目はDRBFM分析から生成されました',
    drbfmLinkTooltip: 'DRBFM分析結果を表示',
  },

  // Profile
  profile: {
    title: 'プロフィール',
    userInfo: 'ユーザー情報',
    name: '名前',
    email: 'メールアドレス',
    role: 'ロール',
    tenant: 'テナント',
    groups: 'グループ',
    security: 'セキュリティ',
    mfa: '多要素認証 (MFA)',
    mfaEnabled: '有効',
    mfaDisabled: '無効',
    lastVerified: '最終認証日時',
    backupCodesRemaining: 'バックアップコード残数',
    manageMfa: 'MFA設定管理',
    enableMfa: 'MFAを有効化',
    mfaNotAvailable: 'MFA情報を取得できませんでした',
    activeSessions: 'アクティブセッション',
    noActiveSessions: 'アクティブなセッションがありません',
    trustedDevices: '信頼済みデバイス',
    noTrustedDevices: '信頼済みデバイスがありません',
    unnamedDevice: '名前のないデバイス',
    sessionDeleted: 'セッションを削除しました',
    deviceRemoved: '信頼済みデバイスを削除しました',
    failedToDelete: 'セッションの削除に失敗しました',
    failedToRemove: '信頼済みデバイスの削除に失敗しました',
    failedToLoadProfile: 'プロフィールデータの読み込みに失敗しました',
    deleteSession: 'セッションを削除',
    removeTrustedDevice: '信頼済みデバイスを削除',
  },

  // Chat UI (shared across chat panels)
  chat: {
    addContext: 'コンテキスト追加',
    attachFile: 'ファイル添付',
    attachDocument: 'ドキュメントを添付',
    allSources: 'AIONA DB',
    allSourcesTooltip: '社内技術文書のみを検索',
    assistant: 'アシスタント',
    basedOn: '根拠:',
    chatTab: 'チャット',
    commands: 'コマンド',
    emptyTitle: '下の入力欄にメッセージを入力して会話を始めましょう',
    emptyDescription: 'ドキュメントの検索、要約の作成、質問への回答をお手伝いします',
    enterKey: '確定',
    file: 'ファイル',
    files: 'ファイル',
    fileMentionHint: 'ファイルを検索するか @ でメンションできます',
    fileSearchPlaceholder: 'ファイルを検索...',
    filesCount: '{{count}}件のファイル',
    filesSelected: '{{count}}件選択中',
    generateSummary: '要約を生成',
    inContext: 'コンテキスト内',
    webOnly: 'Web検索（準備中）',
    webOnlyTooltip: '現在はWeb検索を実行せず、社内技術文書のみで回答します',
    internalOnly: '社内文書のみ',
    internalOnlyTooltip: '社内技術文書のみを検索',
    messagePlaceholder: 'メッセージを入力...',
    modeSelectorTitle: 'モードを選択',
    modeSelectorHint: '/help, /ask, /plan, /drbfm でも切り替え可能',
    newConversation: '新しい会話',
    noFiles: 'ファイルがありません',
    noFilesFound: 'ファイルが見つかりません',
    openDocument: 'ドキュメントを開く',
    quickActions: 'クイックアクション',
    referenceDocuments: '参照ドキュメント',
    relevance: '関連度',
    relevanceHigh: '高',
    relevanceMedium: '中',
    relevanceLow: '低',
    relatedPassage: '関連箇所',
    relatedPassages: '{{count}}件の関連箇所',
    relatedPassagesUnit: '関連箇所',
    showRelatedPassages: '同じファイルの他の{{unit}} {{count}} 件を表示',
    hideRelatedPassages: '同じファイルの他の関連箇所を隠す',
    searchDocuments: 'ドキュメントを検索',
    searchResultsCount: '{{count}}件の結果',
    searchedFor: '検索キーワード',
    settings: 'チャット設定',
    sourceLabel: 'ソース: {{type}}',
    sourceListTitle: '{{title}} ({{count}}件)',
    sources: '参照元',
    sourcesTab: 'ソース',
    systemMessage: 'システムメッセージ',
    thinking: '考え中...',
    stillThinking: 'まだ考え中...',
    almostThere: 'もう少し...',
    sendMessage: 'メッセージを送信 (Enter)',
    inputPlaceholder: '質問、検索、何でもお気軽に...',
    notionEmptyDescription: 'ドキュメントについてAIONAに質問したり、文章作成や分析などのサポートを受けることができます。',
    newChat: '新しいチャット',
    newThread: '新しいスレッド',
    chatFallback: 'チャット',
    modeSwitched: 'モードを「{{mode}}」に切り替えました。{{description}}',
    noFilesSelectedForSummary: 'ファイルが選択されていません。ファイルを選択してから再度お試しください。',
    deepAnalysisInProgress: '詳細な技術分析を実行中です...',
    fileAnalysisInProgress: 'ファイルを分析中です...',
    summaryUnavailable: 'サマリーを取得できませんでした。',
    summary: '要約',
    deepTechnicalAnalysis: '詳細技術分析',
    singleFileSummaryHeading: '## {{title}} の{{type}}',
    multiFileSummaryHeading: '## 選択されたファイル（{{count}}件）の{{type}}',
    individualFileSummariesHeading: '### 個別ファイルの要約',
    individualFileAnalysesHeading: '### 個別ファイルの技術分析',
    combinedTechnicalAnalysisHeading: '### 統合技術分析',
    combinedTechnicalInsightsHeading: '### 統合技術的知見',
    summaryError: 'ファイルの要約中にエラーが発生しました。もう一度お試しください。',
    askingAboutFiles: '📎 {{count}}件のファイルに対して質問中: {{fileNames}}',
    fileAddedToContext: '✅ ファイルをコンテキストに追加しました: {{name}}',
    history: 'チャット履歴',
    noHistory: 'チャット履歴がありません',
    pinned: 'ピン留め',
    recentChats: '最近のチャット',
    pinThread: 'ピン留めする',
    unpinThread: 'ピン留めを解除',
    pinThreadAria: '{{title}}をピン留め',
    unpinThreadAria: '{{title}}のピン留めを解除',
    verificationBasedOnDocuments: '文書に基づく回答',
    verificationPartlyUnsupported: '一部裏付けなし',
    verificationNeedsReviewLabel: '要確認箇所あり',
    verificationDetailsTitle: '回答の根拠チェック',
    verificationDetailsDescription: '回答文中の色付き部分が検証結果です。緑は文書に裏付けのある記述、オレンジは裏付けが確認できない記述を示します。',
    verificationSupportedClaims: '文書で裏付けあり（緑）: {{count}}文',
    verificationUnsupportedClaims: '裏付けなし（オレンジ）: {{count}}文',
    verificationWeakCitations: '関連性の低い参照: {{count}}件',
    verificationSupportedTitle: '文書で裏付けあり',
    verificationUnsupportedTitle: '裏付けなし',
    generalFallbackWarning: 'この回答はナレッジベースの文書に基づいていません。一般知識による回答のため、正確性をご確認ください。',
    verificationNeedsReview: '回答の根拠に確認が必要な箇所があります。上の「回答の根拠チェック」を開いて詳細をご確認ください。',
    retryWithMode: '別モードで再質問 →',
    deleteConfirm: 'このドキュメントを削除しますか？この操作は元に戻せません。',
    editTags: 'タグ編集',
    tagInputPlaceholder: 'タグを入力してEnter',
    viewSource: 'ソースを表示',
    modes: {
      help: {
        name: 'ヘルプ',
        description: 'システムの使い方とコマンド一覧',
      },
      settings: {
        name: '設定',
        description: 'データソース状態・利用統計',
      },
      ask: {
        name: 'Q&A',
        description: '質問応答モード（デフォルト）',
      },
      plan: {
        name: '設計深掘り',
        description: '設計に関する深い議論',
      },
      drbfm: {
        name: 'DRBFM分析',
        description: 'DRBFM分析サポート',
      },
      verification: {
        name: '設計検証',
        description: '設計検証項目の分析・改善支援',
      },
      cad: {
        name: 'CAD分析',
        description: 'CADデータの構造・設計レビュー',
      },
    },
  },
};

export default jaTranslations;
